import axios from "axios";
import setUpAxios from "../helperFunctions/helperFunctions";

import {
  FETCH_BONUSES_DATA_SUCCESS,
  FETCH_BONUSES_DATA_FAILURE,
  FETCH_LEADERBOARD_DATA_SUCCESS,
  FETCH_LEADERBOARD_DATA_FAILURE,
  FETCH_ORGANIZATION_DATA_SUCCESS,
  FETCH_ORGANIZATION_DATA_FAILURE,
  FETCH_PARTICIPATION_DATA_SUCCESS,
  FETCH_PARTICIPATION_DATA_FAILURE,
  FETCH_TOP_WORDS_DATA_SUCCESS,
  FETCH_TOP_WORDS_DATA_FAILURE,
} from "../constants/actions";

export const fetchParticipationData = (dispatch: any) => {
  setUpAxios();
  axios
    .get("/api/v1/analytics/engagement/minigraph")
    .then((response) => {
      dispatch({
        type: FETCH_PARTICIPATION_DATA_SUCCESS,
        data: response.data,
      });
    })
    .catch(() => {
      dispatch({
        type: FETCH_PARTICIPATION_DATA_FAILURE,
      });
    });
};

export const fetchOrganizationData = (dispatch: any) => {
  setUpAxios();
  axios({
    method: "get",
    url: "/api/v1/analytics/org_chart",
    headers: { "Content-Type": "text/html" },
  })
    .then((response) => {
      $("#org-chart-container").html(response.data.html);
      dispatch({
        type: FETCH_ORGANIZATION_DATA_SUCCESS,
        data: response.data,
      });
    })
    .catch(() => {
      dispatch({
        type: FETCH_ORGANIZATION_DATA_FAILURE,
      });
    });
};

export const fetchLeaderboardData = (dispatch: any, teamId: string) => {
  setUpAxios();
  axios
    .get(
      `/api/v1/analytics/leaderboards/minigraph?direction=received&team=${teamId}`
    )
    .then((response) => {
      dispatch({
        type: FETCH_LEADERBOARD_DATA_SUCCESS,
        data: response.data.result,
      });
    })
    .catch(() => {
      dispatch({
        type: FETCH_LEADERBOARD_DATA_FAILURE,
      });
    });
};

export const fetchBonusesData = (dispatch: any) => {
  setUpAxios();
  axios
    .get("/api/v1/analytics/bonus_totals")
    .then((response) => {
      dispatch({
        type: FETCH_BONUSES_DATA_SUCCESS,
        data: response.data.result,
      });
    })
    .catch(() => {
      dispatch({
        type: FETCH_BONUSES_DATA_FAILURE,
      });
    });
};

export const fetchTopWordsData = (dispatch: any) => {
  setUpAxios();
  axios
    .get("/api/v1/analytics/words/minigraph")
    .then((response) => {
      dispatch({
        type: FETCH_TOP_WORDS_DATA_SUCCESS,
        data: response.data,
      });
    })
    .catch(() => {
      dispatch({
        type: FETCH_TOP_WORDS_DATA_FAILURE,
      });
    });
};
